/**
 * Lugares del sitio de turismo, ahora servidos por MuniSuite.
 *
 * El contenido dejó de vivir en el backend viejo (Mongo) y pasó a MuniSuite, que expone
 * `/api/v1/web-management/places` sin pedir autenticación para leer, que es lo que este sitio
 * necesita.
 *
 * Configurar `REACT_APP_API_URL` con la API de MuniSuite, SIN el sufijo de versión:
 *   REACT_APP_API_URL=https://api-suite.lagranja.gob.ar
 *
 * Toda la traducción vive acá, igual que antes: los componentes siguen recibiendo `{ id, title,
 * category, description, location, address, phone, image }` y no se tocó ninguna pantalla.
 */

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.lagranja.gob.ar';

/**
 * Convierte un lugar de MuniSuite al formato que usan el mapa y los componentes.
 *
 * La ubicación va como par [lat, lng] porque es lo que espera el mapa. En MuniSuite son dos
 * columnas separadas, `latitude` y `longitude`.
 */
function mapPlaceFromApi(place) {
  const lat = typeof place.latitude === 'number' ? place.latitude : null;
  const lng = typeof place.longitude === 'number' ? place.longitude : null;
  return {
    id: place.id,
    title: place.title || '',
    category: place.category || place.webPlaceCategory?.name || 'Lugar',
    description: place.content || place.excerpt || '',
    location: lat !== null && lng !== null ? [lat, lng] : [0, 0],
    address: place.address || '',
    phone: place.phone || '',
    image:
      place.featuredImage ||
      (Array.isArray(place.images) && place.images[0] ? place.images[0] : null),
  };
}

/** ¿Tiene una ubicación usable? El mapa no puede dibujar un lugar sin coordenadas. */
function tieneUbicacion(place) {
  return (
    typeof place.latitude === 'number' &&
    typeof place.longitude === 'number' &&
    !(place.latitude === 0 && place.longitude === 0)
  );
}

/**
 * Los lugares publicados y con ubicación válida.
 *
 * MuniSuite devuelve también borradores y archivados —en Mongo el borrador no existía—, así que
 * el filtro por `status` es nuevo y es el que evita que un borrador salga al sitio.
 */
export async function getPlaces() {
  if (!API_BASE) {
    return [];
  }
  try {
    const res = await fetch(
      `${API_BASE.replace(/\/$/, '')}/api/v1/web-management/places`,
    );
    if (!res.ok) return [];
    const data = await res.json();
    const list = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
    return list
      .filter((p) => p.status === 'PUBLISHED' && tieneUbicacion(p))
      .map(mapPlaceFromApi);
  } catch (err) {
    console.warn('Error al cargar lugares de turismo:', err);
    return [];
  }
}
